module.exports = "./img/3bca75bebb2408b3d0a840a835e1a946.png";